import { RULE_TEST_STATUS } from 'Common/enums';

const useGetManageRuleTestsData = () => {
    // TODO: replace mockData with API integration in future stories.
    const mockData: RuleTest[] = [
        {
            id: 1,
            isNewRuleTest: true,
            templateRepositoryId: 1,
            createdOn: '2023-12-31',
            createdBy: 'LN, FN',
            start: '2023-11-31',
            end: '2023-12-05',
            status: RULE_TEST_STATUS.FINISHED,
            _formatted: {
                isNewRuleTest: true,
                createdOn: '2023-12-31',
                createdBy: 'LN, FN',
                duration: '3 Days',
                start: '2023-11-31',
                end: '2023-12-05',
                status: RULE_TEST_STATUS.FINISHED
            }
        },
        {
            id: 2,
            isNewRuleTest: false,
            templateRepositoryId: 1,
            createdOn: '2023-12-31',
            createdBy: 'LN, FN',
            start: '2023-11-31',
            end: '2023-12-05',
            status: RULE_TEST_STATUS.IN_PROGRESS,
            _formatted: {
                isNewRuleTest: false,
                createdOn: '2023-12-31',
                createdBy: 'LN, FN',
                duration: '3 Days',
                start: '2023-11-31',
                end: '2023-12-05',
                status: RULE_TEST_STATUS.IN_PROGRESS
            }
        },
        {
            id: 3,
            isNewRuleTest: false,
            templateRepositoryId: 1,
            createdOn: '2023-12-31',
            createdBy: 'LN, FN',
            start: '2023-11-31',
            end: '2023-12-05',
            status: RULE_TEST_STATUS.CANCELLED,
            _formatted: {
                isNewRuleTest: false,
                createdOn: '2023-12-31',
                createdBy: 'LN, FN',
                duration: '3 Days',
                start: '2023-11-31',
                end: '2023-12-05',
                status: RULE_TEST_STATUS.CANCELLED
            }
        },
        {
            id: 4,
            isNewRuleTest: false,
            templateRepositoryId: 1,
            createdOn: '2023-12-31',
            createdBy: 'LN, FN',
            start: '2023-11-31',
            end: '2023-12-05',
            status: RULE_TEST_STATUS.FAILED,
            _formatted: {
                isNewRuleTest: false,
                createdOn: '2023-12-31',
                createdBy: 'LN, FN',
                duration: '3 Days',
                start: '2023-11-31',
                end: '2023-12-05',
                status: RULE_TEST_STATUS.FAILED
            }
        }
    ];
    return mockData;
};

export default useGetManageRuleTestsData;
